import React from 'react';

import { updateAnexoAprovacao } from '@app/api/demanda';
import { Button, FormatText, FormTextArea, FormSubmitButton, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal } from 'antd';
import * as Yup from 'yup';

interface Props {
  onUpdate: any;
  exibirModal: boolean;
  setExibirModal: React.Dispatch<React.SetStateAction<boolean>>;
  values: any;
}

function ModalValidarAnexoPQ(props: Props) {
  const { onUpdate, exibirModal, setExibirModal, values } = props;

  const handleSubmit = () => {
    updateAnexoAprovacao(values).then(data => {
      onUpdate();
      setExibirModal(false)
    });
  };

  const handleCancel = () => {
      setExibirModal(false)
  }

  return (
    <Modal title="Confirmar" width="680px" visible={exibirModal} onCancel={() => handleCancel()} footer={null}>
      <MasterDetailForm
        actions={[
          <Button key="discordarBtn" type="link" onClick={() => handleCancel()}>
            Não
          </Button>,
          <Button key="concordarBtn" type="primary" onClick={() => handleSubmit()}>
            Sim
          </Button>,
        ]}>
        <Widget>
          <Row>
            <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
              Você está certo de que não constam quaisquer informações de preços na Planilha de Quantidades?
            </p>
            <p></p>
          </Row>
        </Widget>
      </MasterDetailForm>
    </Modal>
  );
}

export default ModalValidarAnexoPQ;
